import React, { Fragment, useEffect } from "react";
import { MaskedInput } from "antd-mask-input";
import { useTranslation } from "react-i18next";

const FormattedTaxRegistrationNumber = ({ action, field, onChange, state, value, data, errors, ...props }) => {
  const { t } = useTranslation("TaxRegistrationNumber");
  const handleInputChange = (e) => {
    onChange(field, e.unmaskedValue);
  };

  useEffect(() => {
    if (value) onChange(field, value.replaceAll("-", ""));
  }, []);

  const errorMessage = errors.tax_registration_number;

  return (
    <Fragment>
      <div style={{ paddingBottom: "8px" }}>
        <label style={{ fontWeight: "600" }}>{t("tax_registration_number")}</label>
      </div>
      <MaskedInput
        value={value}
        mask={"000-000-000"}
        onChange={handleInputChange}
        style={errorMessage ? { borderColor: "#ff4d4f" } : {}}
      />
      {errorMessage && <div style={{ color: "#ff4d4f" }}>{errorMessage}</div>}
    </Fragment>
  );
};

export default FormattedTaxRegistrationNumber;
